import { render, staticRenderFns } from "./MedicationBox.vue?vue&type=template&id=e6909eac&scoped=true"
import script from "./MedicationBox.vue?vue&type=script&lang=js"
export * from "./MedicationBox.vue?vue&type=script&lang=js"
import style0 from "./MedicationBox.vue?vue&type=style&index=0&id=e6909eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6909eac",
  null
  
)

export default component.exports